import { render, staticRenderFns } from "./SediCal.vue?vue&type=template&id=76efd6ff&scoped=true&"
import script from "./SediCal.vue?vue&type=script&lang=js&"
export * from "./SediCal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76efd6ff",
  null
  
)

export default component.exports